import { createFileRoute, redirect } from "@tanstack/react-router";

/** 模板市场已下线：统一落到抽取模板列表（kind=元数据） */
export const Route = createFileRoute("/_app/data-center/tmpl/metadata")({
  beforeLoad: () => {
    throw redirect({ to: "/data-center/tmpl", search: { kind: "metadata" } });
  },
});
